import { default as _91_46_46_46slug_93ASdet0gzHEMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/[...slug].vue?macro=true";
import { default as indextmpdEcIa5KMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/auth/index.vue?macro=true";
import { default as indexf10YQhXVJMMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93eLCPJyvvyKMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93tcarKoZot4Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93iCsl7L5Tq0Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93C8pxRgUoN0Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/news/[slug].vue?macro=true";
import { default as organisationsZ6bX0Was1UMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsreyR5xCIaIMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsBYzeGlHQ64Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexeH3ijPXS5bMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/processes/index.vue?macro=true";
import { default as dungeonjJjjW11jAiMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputscZVVTrLA9gMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexmmbKbNRgApMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/secret/index.vue?macro=true";
import { default as indexQzc3U38LuLMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDatapzWGuZelDXMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassU6CovXAfqeMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93aM3s3WaHBMMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexmD0LEhQjNpMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataq4NPa8bjOKMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFields69aZWcglnoMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsWONDIA5hFwMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsJ9yjEZInk4Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_934B5IR2fB8HMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexPcDKXcUtnCMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesyaCg6FDdlwMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatazWH3VBJJzCMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93DkxBYO2TbFMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexIl5RQTESd4Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesZZ7dF0Al0RMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataZs46puk9SuMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93e6HqySwSexMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexXNo0NXifLbMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDatavxFA4PSEchMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_936jqzMqsUeMMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as index65pwDL5J4sMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataAk0fR90oKoMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassBqWuCgfhI9Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsXetAGzC8gIMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93qRvoYdbvwOMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as index6X3hgMFkWiMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitieskhswg2j0PUMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseData2ImCRpkB2vMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsRhlabebrBZMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93nKVafWBpYxMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexnKL0FGN4p7Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesAQXwueWb41Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDatagJpBUNXLhSMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsjgF37ztzdrMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93PhsnQwrcLNMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexB7Mcwkwz71Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataESv7FmjEMWMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatarL0Az1Pqy2Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93zeBqiqlK8GMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexwOuYDDtrauMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatawXwLSI3OC1Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93loFrN0NWYtMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexwNvvkchM11Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsTbiBfnA2UeMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataBEZpOkAWJyMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93cGALgVtSDpMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexgaoIlHq1t5Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesiFDwQYMUAHMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesr1QxjMhCE0Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsUTcEjhgKT6Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataVaGjKxRfutMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasyCTSiNcZ8BMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesUXW55NOFenMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93k3ebmSrqKSMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexgQ8toWSox1Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsoTgsEHUsPvMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltzu82U5wz7vMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseData0SPJVnguZGMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsOpv1Q0mN00Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93J8DBjXvAy4Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexI0I76qxb46Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsma7o7mwYNsMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesxX7AwIoNfDMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDatargyoQBqa1HMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93GejiXPlWviMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/processes/[id].vue?macro=true";
import { default as indexS1eKlerYSHMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_93YHZihd0IHYMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as index2G80JHbUHCMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersgQAWVO2eZDMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesKYs9exm4JIMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsT6oBajqBfeMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatawyYogic4BRMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesBTtmfBnvmjMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptZlb7HIJ6s7Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementY3WnhygN06Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersikteAxwJlfMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93W2xthBs0N4Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexBS08QS5rlFMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsNTtbZ5VcIyMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiessDiZdMaKqqMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatan7XkICp2CyMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureGkzMOxAF9JMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_935vaxVkKbnWMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexBX869fKYlWMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/index.vue?macro=true";
import { default as users8Vt5awBr27Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users.vue?macro=true";
import { default as settingsqSkFel0mVxMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesNb930Gpz97Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseData94yu0v5sWzMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93bWMbUs7dlfMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexKkuhx2KnjXMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as servicehCH0fZV6UUMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service.vue?macro=true";
import { default as languagepbcLchvywjMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataLwMldtzyLuMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesnETKFd9SbvMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementEv3JaxGOxfMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersGBm4t0pejbMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93a9127tADy5Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataRY3Zwz5oRqMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignaturePeWpwzV00vMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93GxBUz6UBTzMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/users/[id].vue?macro=true";
import { default as indexyQFxEicRIXMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/users/index.vue?macro=true";
import { default as settings33s2iyetugMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings.vue?macro=true";
import { default as signatureMAY9fXrXOeMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/signature.vue?macro=true";
import { default as sportbizzs35NHYnUIYMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93bctDhqnGs8Meta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93DTCW1LEyXpMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexZp9u1FQBKzMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93rQ10fNhorDMeta } from "/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93ASdet0gzHEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indextmpdEcIa5KMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexf10YQhXVJMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93eLCPJyvvyKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93tcarKoZot4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93iCsl7L5Tq0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsZ6bX0Was1UMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexeH3ijPXS5bMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: servicehCH0fZV6UUMeta?.name,
    path: "/service",
    meta: servicehCH0fZV6UUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatawXwLSI3OC1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexQzc3U38LuLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93aM3s3WaHBMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexmD0LEhQjNpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_934B5IR2fB8HMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexPcDKXcUtnCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93DkxBYO2TbFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexIl5RQTESd4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93e6HqySwSexMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexXNo0NXifLbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_936jqzMqsUeMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: index65pwDL5J4sMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93qRvoYdbvwOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: index6X3hgMFkWiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93nKVafWBpYxMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexnKL0FGN4p7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93PhsnQwrcLNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsjgF37ztzdrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexB7Mcwkwz71Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93zeBqiqlK8GMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexwOuYDDtrauMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93loFrN0NWYtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesiFDwQYMUAHMeta?.name,
    path: "parishes",
    meta: parishesiFDwQYMUAHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93cGALgVtSDpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsoTgsEHUsPvMeta?.name,
    path: "regions",
    meta: regionsoTgsEHUsPvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93k3ebmSrqKSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsma7o7mwYNsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93J8DBjXvAy4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexI0I76qxb46Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93GejiXPlWviMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexS1eKlerYSHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsqSkFel0mVxMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersgQAWVO2eZDMeta?.name,
    path: "loginProviders",
    meta: loginProvidersgQAWVO2eZDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93YHZihd0IHYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: index2G80JHbUHCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsNTtbZ5VcIyMeta?.name,
    path: "organisations",
    meta: organisationsNTtbZ5VcIyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93W2xthBs0N4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexBS08QS5rlFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: users8Vt5awBr27Meta?.name,
    path: "users",
    meta: users8Vt5awBr27Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_935vaxVkKbnWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexBX869fKYlWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93bWMbUs7dlfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexKkuhx2KnjXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings33s2iyetugMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93a9127tADy5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93GxBUz6UBTzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexyQFxEicRIXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureMAY9fXrXOeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzs35NHYnUIYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93bctDhqnGs8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93DTCW1LEyXpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexZp9u1FQBKzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93rQ10fNhorDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250528153046/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]